import { Instagram } from 'lucide-react'
import { FaTiktok } from 'react-icons/fa'
import { Link } from 'react-router-dom'

const footerLinks = {
  Sports: [
    { name: 'Football', href: '/sports/football' },
    { name: 'Basketball', href: '/sports/basketball' },
    { name: 'Padel', href: '/sports/padel' },
  ],
  Solutions: [
    { name: 'For Communities', href: '/solutions/communities' },
    { name: 'For Academies', href: '/solutions/academies' },
    { name: 'For Venues', href: '/solutions/venues' },
  ],
  Resources: [
    { name: 'Blog', href: '/blog' },
    { name: 'Contact Us', external: 'https://wa.me/96170510509?text=Hello!%20I%20would%20like%20to%20know%20more%20about%20Statbox.' },
    { name: 'Upload a game', href: '/upload' },
    { name: 'Download App', href: '/app-download' },
  ],
  Company: [
    { name: 'Privacy Policy', href: '/privacy' },
    { name: 'Terms of Service', href: '/terms' },
  ],
}

export const Footer = () => {
  return (
    <footer className="flex-shrink-0 border-t border-[#1a1a1a] pt-10 sm:pt-14 lg:pt-6 pb-[max(2rem,env(safe-area-inset-bottom))] sm:pb-10 lg:pb-6">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-6 sm:gap-8 lg:gap-6 mb-10 sm:mb-12 lg:mb-6">
          {/* Brand */}
          <div className="col-span-2">
            <div className="flex items-center gap-2 mb-3 sm:mb-4">
              <img src="/Logo_Statbox_Transparent.png" alt="Statbox" className="h-6 sm:h-7 w-auto" />
              <img src="/logo_white.png" alt="Statbox" className="h-3 sm:h-3.5 w-auto" />
            </div>
            <p className="text-sm sm:text-[14px] text-[#888] max-w-xs leading-relaxed mb-4 sm:mb-5">
              Statbox turns weekly games into stats, highlights, and a feed your players will obsess over.
            </p>
            <div className="flex items-center gap-2.5">
              <a href="https://www.instagram.com/statboxhq/" target="_blank" rel="noopener noreferrer" className="w-8 h-8 rounded-full bg-[#111] border border-[#1a1a1a] flex items-center justify-center hover:bg-[#1a1a1a] transition-colors" aria-label="Instagram">
                <Instagram className="w-3.5 h-3.5 text-[#666]" />
              </a>
              <a href="https://www.tiktok.com/@statbox.app" target="_blank" rel="noopener noreferrer" className="w-8 h-8 rounded-full bg-[#111] border border-[#1a1a1a] flex items-center justify-center hover:bg-[#1a1a1a] transition-colors" aria-label="TikTok">
                <FaTiktok className="w-3.5 h-3.5 text-[#666]" aria-hidden />
              </a>
            </div>
          </div>

          {/* Link Columns */}
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h3 className="text-xs sm:text-[12px] font-semibold text-[#555] uppercase tracking-wider mb-3 sm:mb-4">{category}</h3>
              <ul className="space-y-2 sm:space-y-2.5">
                {links.map((link) => (
                  <li key={link.name}>
                    {'href' in link && link.href ? (
                      <Link
                        to={link.href}
                        className="text-sm sm:text-[13px] text-[#888] hover:text-white transition-colors block py-0.5"
                      >
                        {link.name}
                      </Link>
                    ) : 'external' in link && link.external ? (
                      <a href={link.external} target="_blank" rel="noopener noreferrer" className="text-sm sm:text-[13px] text-[#888] hover:text-white transition-colors block py-0.5">{link.name}</a>
                    ) : 'action' in link && link.action ? (
                      <button onClick={link.action} className="text-sm sm:text-[13px] text-[#888] hover:text-white transition-colors text-left py-0.5 min-h-[24px] touch-manipulation">{link.name}</button>
                    ) : null}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-[#1a1a1a] pt-5 sm:pt-6 lg:pt-4">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-3 sm:gap-4 text-center sm:text-left">
            <p className="text-xs sm:text-[12px] text-[#555]">
              © {new Date().getFullYear()} Statbox. All rights reserved.
            </p>
            <div className="flex items-center gap-5 sm:pr-20">
              <Link to="/privacy" className="text-xs sm:text-[12px] text-[#555] hover:text-white transition-colors">
                Privacy
              </Link>
              <Link to="/terms" className="text-xs sm:text-[12px] text-[#555] hover:text-white transition-colors">
                Terms
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
